export default __webpack_public_path__ + "static/media/Logo Group.40a3887d.svg";